import { render, staticRenderFns } from "./signatureView.vue?vue&type=template&id=0b2daaa4&scoped=true&"
import script from "./signatureView.vue?vue&type=script&lang=js&"
export * from "./signatureView.vue?vue&type=script&lang=js&"
import style0 from "./signatureView.vue?vue&type=style&index=0&id=0b2daaa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2daaa4",
  null
  
)

export default component.exports